import { AttachmentHistory } from '../../../utils/headers';
import Loading from '../../Loading';
import DataTable from '../../Table/DataTable';

function HistorialAdjuntos({ items, loading }: any) {
    return loading ? (
        <Loading />
    ) : (
        <DataTable headers={AttachmentHistory} loading={loading} options={items} />
    );
}

export default HistorialAdjuntos;
